
export default {
  CREATE_DOMAIN(state, created) {
    if (!state.domains.items) {
      state.domains.items = [];
    }
    state.domains.items.unshift(created);
  },
  DELETE_DOMAIN(state, name) {
    const index = state.domains.items.findIndex( value => value.name === name );

    if ( index !== - 1 ) state.domains.items.splice(index, 1);
  },
  SET_DOMAINS(state, domains) {
    state.domains = domains;
  }
}
